import { FleetManagementStatsOutput, NetGainFilterInput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

export const DRIVER_NET_GAIN_LIMIT = 20;

const fetchNetGainsByDriver = (input: NetGainFilterInput) =>
  driverApi.post<NetGainFilterInput, FleetManagementStatsOutput, 'list'>(`v1/net-gains/overall/by-drivers`, input);

export const useFetchNetGainsByDriverPage = (input: NetGainFilterInput = {}) => {
  return useQuery({
    queryKey: queryKeys.user.fetchNetGainsByDriver(input),
    queryFn: () => fetchNetGainsByDriver(input),
    keepPreviousData: true,
  });
};
